module.exports = __webpack_public_path__ + "media/MRI15-ad.21d4d9ec.mp3";